import { DicomServiceTokenResponse } from '@core/types/DicomServiceTokenResponse';

const USER_FOUND = 'redux-oidc/USER_FOUND';

declare global {
  interface Window {
    store?: any;
  }
}

// Module-level cache so non-React modules (axios interceptors etc.) can read the
// current token without React context. ThemeProvider drives this.
let currentAccessToken: string | null = null;

export const getCurrentDicomServiceAccessToken = (): string | null => currentAccessToken;

// The v4 viewer fork consumed tokens via a redux-oidc store on `window.store`;
// the v5 (v3-based) viewer reads the `authToken` prop instead. We always update
// the module cache, and still dispatch when window.store exists so the v4 fallback works.
const setDicomServiceAccessToken = (dicomServiceToken: DicomServiceTokenResponse) => {
  if (!dicomServiceToken || !dicomServiceToken.token) {
    return;
  }

  currentAccessToken = dicomServiceToken.token.token ?? null;

  if (
    typeof window !== 'undefined' &&
    window.store &&
    typeof window.store.dispatch === 'function'
  ) {
    window.store.dispatch({
      type: USER_FOUND,
      payload: {
        access_token: dicomServiceToken.token.token,
      },
    });
  }
};

export { setDicomServiceAccessToken };
